module.exports = __webpack_public_path__ + "static/img/mp2_lg.04cfa9e.png";